export default __webpack_public_path__ + "static/media/wallet.63ed2e9e.svg";